import { ExportGrantAccountListSchema, ExportGrantChangeResponseSchema, ExportGrantPreviewSchema,
  type ExportGrantAccountList, type ExportGrantChangeResponse, type ExportGrantPreview } from '@youkuai/contracts';

import { apiRequest } from './project-api.ts';

export async function listExportGrantAccounts(token: string, input: { search?: string; afterCode?: string;
  limit?: number; category?: 'CONTRACT_AMOUNT' | 'BANK_ACCOUNT' } = {}): Promise<ExportGrantAccountList> {
  const query = new URLSearchParams({ limit: String(input.limit ?? 50),
    category: input.category ?? 'CONTRACT_AMOUNT' });
  if (input.search?.trim()) query.set('search', input.search.trim());
  if (input.afterCode) query.set('afterCode', input.afterCode);
  return ExportGrantAccountListSchema.parse(await apiRequest(`/operations/export-grants/accounts?${query}`, token));
}

export async function previewExportGrantChange(token: string, input: { targetUserId: string;
  category: 'CONTRACT_AMOUNT' | 'BANK_ACCOUNT'; action: 'GRANT' | 'REVOKE'; reason: string }): Promise<ExportGrantPreview> {
  return ExportGrantPreviewSchema.parse(await apiRequest('/operations/export-grants/previews', token, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ targetUserId: input.targetUserId, category: input.category,
      action: input.action, reason: input.reason.trim() }),
  }));
}

export async function getExportGrantPreview(token: string, previewId: string): Promise<ExportGrantPreview> {
  return ExportGrantPreviewSchema.parse(await apiRequest(
    `/operations/export-grants/previews/${encodeURIComponent(previewId)}`, token));
}

export async function confirmExportGrantChange(token: string, input: { previewId: string;
  idempotencyKey: string }): Promise<ExportGrantChangeResponse> {
  return ExportGrantChangeResponseSchema.parse(await apiRequest(
    `/operations/export-grants/previews/${encodeURIComponent(input.previewId)}/confirm`, token, {
      method: 'POST', headers: { 'Idempotency-Key': input.idempotencyKey },
    }));
}
